// extracted by mini-css-extract-plugin
export default {"row":"Alert_row__8Pyn9","fadeSlide":"Alert_fadeSlide__zUWP-","col":"Alert_col__zyu9J"};